import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import IntlMessageFormat from "intl-messageformat";
import { useStringMap } from "../../utilities/string-map/useStringMap";
import { CloseIcon } from "../../icons/CloseIcon";
import { NakedButton } from "../../naked-button/NakedButton";
import * as Styled from "./MultiSelect.styled";
import { stringMapDefault } from "./SelectMultiOption.stringMap";
const componentName = "SelectedMultiOption";
export const SelectedMultiOption = forwardRef((props, ref) => {
    const { hasDisabledParent, label, removeSelectedValue, secondaryLabel, value, stringMap: stringMapProp, isOptionValid, 
    // deprecated
    onIconClick, ...otherProps } = props;
    const stringMap = useStringMap(componentName, { stringMapDefault, stringMapProp });
    // TODO: update Intl to format using React or throw an error here that React Node label will not render
    const labelString = typeof props.label === "string" ? props.label : "! MISSING STRING LABEL !";
    const removeLabel = typeof stringMap.remove === "function"
        ? stringMap.remove(props)
        : new IntlMessageFormat(stringMap.remove).format({
            label: labelString
        });
    const labelToRender = typeof label === "function" ? label({ searchText: undefined }) : label;
    return (_jsxs(Styled.SelectedMultiOption, { role: "listitem", ref: ref, disabled: hasDisabledParent, "data-testid": "SelectedMultiOption", ...otherProps, isOptionValid: isOptionValid, children: [secondaryLabel && _jsx(Styled.SelectedMultiOptionPrefix, { children: secondaryLabel }), labelToRender, _jsx("input", { type: "hidden", value: value }), !hasDisabledParent && (_jsx(NakedButton, { onClick: removeSelectedValue, "aria-label": removeLabel, children: _jsx(CloseIcon, { size: 7, "aria-hidden": "true" }) }))] }, value));
});
SelectedMultiOption.displayName = componentName;
SelectedMultiOption.defaultProps = {
    isOptionValid: true
};
